export const isFetchingTrueLayerURL = (state: any) => {
    return state?.lendingAPI?.truelayer?.pending;
};

export const getTrueLayerRedirectURL = (state: any) => {
    return state?.lendingAPI?.truelayer?.data?.authorization_url;
};

export const getUrlRequestErrorStatus = (state: any) => {
    return state?.lendingAPI?.truelayer?.error;
};
